import {
  gql,
  MutationFunction,
  MutationResult,
  useMutation
} from '@apollo/client'

interface RequestToRequestTimeSlotProps {
  onCompleted: () => void
}

export interface RequestToRequestTimeSlotResult {
  requestTimeSlot: MutationFunction
  requestTimeSlotLoading: MutationResult['loading']
  requestTimeSlotError: MutationResult['error']
}

type RequestToRequestTimeSlot = (
  props: RequestToRequestTimeSlotProps
) => RequestToRequestTimeSlotResult
/**
 * It calls a mutation to request a time slot.
 */
const useRequestTimeSlot: RequestToRequestTimeSlot = ({ onCompleted }) => {
  const [
    requestTimeSlot,
    { loading: requestTimeSlotLoading, error: requestTimeSlotError }
  ] = useMutation(REQUEST_TIME_SLOT, {
    onCompleted() {
      onCompleted()
    }
  })

  return {
    requestTimeSlot,
    requestTimeSlotLoading,
    requestTimeSlotError
  }
}

export default useRequestTimeSlot

export const REQUEST_TIME_SLOT = gql`
  mutation WidgetUseRequestTimeSlot(
    $schedulableId: ID!
    $peopleGoing: Int!
    $childrenGoing: Int!
    $organizerParticipating: Boolean!
    $contactNumber: String!
    $enthusiastName: String!
    $enthusiastEmail: String!
    $startDate: String!
    $startTime: String!
    $widgetSlug: String!
  ) {
    Consumer_RequestTimeSlot(
      schedulable_id: $schedulableId
      people_going: $peopleGoing
      children_going: $childrenGoing
      organizer_participating: $organizerParticipating
      contact_number: $contactNumber
      enthusiast_name: $enthusiastName
      enthusiast_email: $enthusiastEmail
      start_date: $startDate
      start_time: $startTime
      widget_slug: $widgetSlug
    ) {
      request_for_time_slot_id
    }
  }
`
